import React from "react"
import themeConfig from "../configs/themeConfig"
import classnames from "classnames"

const FullPageLayout = ({ children, centeredLayout, ...rest }) => {
  return (
    <div
      className={classnames(
        "full-layout wrapper bg-full-screen-image blank-page dark-layout",
        {
          "layout-dark": themeConfig.layoutDark
        }
      )}
      {...(centeredLayout === false ? {style: {backgroundAttachment: "fixed"}} : {})}
    >
      <div className="app-content">
        <div className="content-wrapper">
          <div className="content-body">
            {centeredLayout !== false ? (<div className="flexbox-container">
              <main className="main w-100">{children}</main>
            </div>) : (<div style={{ minHeight: "100vh", padding: "calc(2.2rem - 0.4rem) 2.2rem 0"}}>{children}</div>)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FullPageLayout
